<template>
    <div>
      <canvas ref="qrcodeCanvas"></canvas>
    </div>
  </template>
   
  <script>
  import QRCode from 'qrcode'
   
  export default {
    name: 'QrCodeComponent',
    props: {
      text: {
        type: String,
        required: true
      }
    },
    mounted() {
      this.generateQRCode()
    },
    methods: {
      generateQRCode() {
        const canvas = this.$refs.qrcodeCanvas
        QRCode.toCanvas(canvas, this.text, error => {
          if (error) console.error(error)
        })
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/qrcode.vue